import { useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    // Dispatch custom event to notify other components
    window.dispatchEvent(new Event('authStateChanged'));
  }, []);

  const verifyToken = useCallback(async () => {
    const userData = localStorage.getItem('user');
    
    if (!userData) {
      setLoading(false);
      return;
    }

    // Always set user from localStorage first
    try {
      setUser(JSON.parse(userData));
      // Dispatch custom event to notify other components
      window.dispatchEvent(new Event('authStateChanged'));
    } catch (error) {
      console.error('Error parsing user data:', error);
      logout();
      setLoading(false);
      return;
    }

    // Then verify token in background (optional)
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // console.log('Verifying token in background...');
        const response = await authAPI.verifyToken();
        // console.log('Token verification response:', response.data);
        // console.log(response.data.statusCode)
        if (response.data.statusCode !== 200) {
          logout();
        }
        // Only logout on explicit 401 status, not on other failures
        // if (response.data.status !== 200) {
        //   logout();
        // }
      } catch (error) {
        // Only logout on 401 unauthorized error, not on network failures
        if (error.response?.status === 401) {
          logout();
        }
        // console.error('Token verification failed (background check):', error);
      }
    }
    
    setLoading(false);
  }, [logout]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return { user, loading, logout, verifyToken };
};